import React from 'react';
import {PasskeySetup} from './PasskeySetup';
import {PageLayout} from '../shell/PageLayout';

export function PasskeyPage() {
    return (
        <PageLayout
            title="Passkey"
            description="Register a passkey for passwordless sign-in to the admin panel."
        >
            <PasskeySetup forceVisible/>
        </PageLayout>
    );
}
